import './SegmentedControl.css'

import { cx } from '../utilities/cx'

export type SegmentedControlOption<T extends string = string> = {
  value: T
  label: string
  disabled?: boolean
}

export type SegmentedControlProps<T extends string = string> = {
  className?: string
  options: SegmentedControlOption<T>[]
  value: T
  ariaLabel?: string
  onChange: (value: T) => void
}

export const SegmentedControl = <T extends string = string>(props: SegmentedControlProps<T>) => {
  const { className, options, value, ariaLabel, onChange } = props

  return (
    <div className={cx('segmented-control', className)} role="group" aria-label={ariaLabel}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className={cx('segmented-control__option', {
            'segmented-control__option--active': option.value === value,
            'segmented-control__option--disabled': !!option.disabled,
          })}
          disabled={option.disabled}
          aria-pressed={option.value === value}
          onClick={() => {
            if (option.disabled || option.value === value) return
            onChange(option.value)
          }}
        >
          {option.label}
        </button>
      ))}
    </div>
  )
}
